// import { EMP_ATTENDANCE } from "../action_types";
const initialstate = {
    userGroups:null, 
    groupsWithSkills:null, 
    searchByDeptName: "",
    searchByGroupId: "",
    skill_id:[]
  };
  export const UserGroupMatrix = (state = initialstate, { type, payload }) => {
    switch (type) {
      case "SET_CHECKED": {
        return {
          ...state,
          skill_id: [...state.skill_id,payload]
        };
      } 
      case "SET_UNCHECKED": {
        return {
          ...state,
          skill_id: state.skill_id.filter((item) => item !== payload)
        };
      }
      case "GET_USER_GROUPS": {
        return {
          ...state,
          userGroups: payload,
        };
      }
      case "GET_GROUPS_WITH_SKILLS": {
        return {
          ...state,
          groupsWithSkills: payload,
        };
      }
      case "SET_SEARCH_DEPT_NAME": {
        return {
          ...state,
          searchByDeptName: payload,
        };
      }
      case "SET_SEARCH_GROUP_ID": {
        return {
          ...state,
          searchByGroupId: payload,
        };
      }

      default: {
        return { ...state };
      }
    }
  };